import styled from 'styled-components';

const AccordionColumnStyled = styled.div`
  display: inline-flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: auto;
  width: 100%;
  @media (min-width: 768px) {
    width: 50%;
    &:first-of-type {
      padding-right: 16px;
    }
    &:last-of-type {
      padding-left: 16px;
    }
  }
`;

export default AccordionColumnStyled;
